import React from "react";
import PropTypes from "prop-types";
import { replaceTextWithValues } from "src/common/utils/text-replace";
import cx from "classnames";
import "./Price.scss";

const Savings = (props) => {
  let price;
  switch (props.type) {
    case "slash":
      price = props.was_price.formatted;
      break;
    case "saved":
      price = props.price.formatted;
      break;
    default:
      break;
  }
  return (
    <p className={`saving-price saving-price--${props.type}`}>
      {props.savingPriceString
        ? replaceTextWithValues(props.savingPriceString, { price })
        : price}
    </p>
  );
};

const Price = (props) => {
  if (!props.price) {
    return null;
  }
  return (
    <div
      className={cx("pricing", {
        [`pricing--${props.savingsType}`]: props.savingsType && props.savings,
        [props.className]: props.className,
      })}
    >
      <p className="current">
        {replaceTextWithValues(props.priceString, {
          price: props.price.formatted,
        })}
      </p>
      {props.savings && props.savingsType && (
        <Savings
          type={props.savingsType}
          savingPriceString={props.savingPriceString}
          {...props.savings}
        />
      )}
    </div>
  );
};

Price.defaultProps = {
  priceString: "%{price}",
  savingPriceString: "%{price}",
  savingsType: "slash",
};

Price.propTypes = {
  className: PropTypes.string,
  savingsType: PropTypes.string,
  priceString: PropTypes.string,
  savingPriceString: PropTypes.string,
  savings: PropTypes.object,
  price: PropTypes.shape({
    amount: PropTypes.string.isRequired,
    formatted: PropTypes.string.isRequired,
  }).isRequired,
};

Savings.propTypes = {
  type: PropTypes.string.isRequired,
  savingPriceString: PropTypes.string.isRequired,
  price: PropTypes.shape({
    formatted: PropTypes.string.isRequired,
  }),
  was_price: PropTypes.shape({
    formatted: PropTypes.string.isRequired,
  }),
};

export default Price;
